import { useState } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://businessdevelopmentauthority.net';

const AIConsultingPage: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d46pupl34biqimnfo7s0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('Message sent successfully!');
        form.reset();
      } else {
        alert('Failed to send message. Please try again.');
      }
    } catch (error) {
      alert('Failed to send message. Please try again.');
    }
  };

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d46pupl34biqimnfo7sg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('Successfully subscribed to newsletter!');
        form.reset();
      } else {
        alert('Failed to subscribe. Please try again.');
      }
    } catch (error) {
      alert('Failed to subscribe. Please try again.');
    }
  };

  const openVideoModal = () => {
    setIsVideoModalOpen(true);
  };

  const closeVideoModal = () => {
    setIsVideoModalOpen(false);
  };

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${SITE_URL}/ai-consulting`,
        'url': `${SITE_URL}/ai-consulting`,
        'name': 'AI Consulting Authority - Improve Your Business with AI Strategy',
        'description': 'AI Consulting Authority provides AI strategy, workflow automation, AI scaling, prompt engineering, cybersecurity, cloud computing, and IT management services.',
        'isPartOf': { '@id': SITE_URL },
      },
      {
        '@type': 'LocalBusiness',
        '@id': `${SITE_URL}/ai-consulting#business`,
        'name': 'AI Consulting Authority Inc.',
        'url': `${SITE_URL}/ai-consulting`,
        'description': 'We are experienced professionals who care about your success. Transform your business with cutting-edge AI solutions tailored to your industry.',
        'telephone': '+1-928-963-2760',
        'email': 'jeffery@aiconsultingauthority.com',
        'address': {
          '@type': 'PostalAddress',
          'streetAddress': '725 E Road 2 N Unit 1494',
          'addressLocality': 'Chino Valley',
          'addressRegion': 'AZ',
          'postalCode': '86323',
          'addressCountry': 'US',
        },
        'geo': {
          '@type': 'GeoCoordinates',
          'latitude': '34.7669',
          'longitude': '-112.4535',
        },
        'openingHoursSpecification': [
          {
            '@type': 'OpeningHoursSpecification',
            'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            'opens': '10:00',
            'closes': '18:00',
          },
        ],
        'sameAs': [
          'https://www.facebook.com/profile.php?id=61587057361355',
          'https://x.com/AIConsultingAut',
          'https://www.instagram.com/aiconsultingauthority/',
          'https://www.linkedin.com/in/jeffery-long-23b02a38a/',
          'https://tiktok.com/@aiconsultingauthority',
        ],
        'hasOfferCatalog': {
          '@type': 'OfferCatalog',
          'name': 'AI Business Services',
          'itemListElement': [
            { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'AI Consulting' } },
            { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'AI Strategy Development' } },
            { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'AI Workflow Automation' } },
            { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'AI Prompt Engineering' } },
            { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Cybersecurity' } },
            { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'Cloud Computing' } },
            { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': 'IT Management' } },
          ],
        },
      },
      {
        '@type': 'Person',
        'name': 'Jeffery Long',
        'jobTitle': 'AI Consulting Authority Founder',
        'url': 'https://www.linkedin.com/in/jeffery-long-23b02a38a/',
        'worksFor': {
          '@type': 'Organization',
          'name': 'AI Consulting Authority Inc.',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="min-h-screen">
        {/* Top Contact Bar */}
        <div className="bg-gray-800 text-white py-3">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-between items-center text-sm">
              <div className="flex flex-wrap items-center space-x-6">
                <a href="mailto:jeffery@aiconsultingauthority.com" className="hover:text-blue-200 cursor-pointer">
                  <i className="ri-mail-line mr-1"></i>jeffery@aiconsultingauthority.com
                </a>
                <a href="tel:+1-928-963-2760" className="hover:text-blue-200 cursor-pointer">
                  <i className="ri-phone-line mr-1"></i>+1-928-963-2760
                </a>
              </div>
              <div className="flex items-center space-x-4">
                <div className="flex items-center">
                  <i className="ri-map-pin-line mr-2 text-blue-400"></i>
                  <span>725 E Road 2 N Unit 1494, Chino Valley, AZ 86323</span>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="flex space-x-2">
                    <a href="https://www.facebook.com/profile.php?id=61587057361355" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors">
                      <i className="ri-facebook-fill"></i>
                    </a>
                    <a href="https://x.com/AIConsultingAut" className="text-white hover:text-blue-400 transition-colors">
                      <i className="ri-twitter-fill"></i>
                    </a>
                    <a href="https://www.instagram.com/aiconsultingauthority/" className="text-white hover:text-blue-400 transition-colors">
                      <i className="ri-instagram-fill"></i>
                    </a>
                    <a href="https://www.linkedin.com/in/jeffery-long-23b02a38a/" className="text-white hover:text-blue-400 transition-colors">
                      <i className="ri-linkedin-fill"></i>
                    </a>
                    <a href="https://tiktok.com/@aiconsultingauthority" className="text-white hover:text-blue-400 transition-colors">
                      <i className="ri-tiktok-fill"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <header className="bg-white shadow-lg sticky top-0 z-50">
          <div className="container mx-auto px-4">
            <div className="flex justify-between items-center py-4">
              <div className="flex items-center">
                <a href="/">
                  <h1 className="text-2xl font-bold text-gray-800">AI Consulting Authority</h1>
                </a>
              </div>
              <nav className="hidden lg:flex items-center space-x-8">
                <a href="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Home</a>
                <a href="/ai-consulting" className="text-blue-600 font-semibold">AI Consulting</a>
                <a href="/real-estate" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Real Estate</a>
                <a href="/ai-book" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">AI Books</a>
                <a href="/travel-authority" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Travel</a>
                <a href="/books" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Books</a>
              </nav>
              <div className="hidden lg:flex items-center space-x-4">
                <button className="text-gray-600 hover:text-blue-600 transition-colors">
                  <i className="ri-search-line text-lg"></i>
                </button>
                <a className="text-gray-600 hover:text-blue-600 transition-colors" href="/login">
                  <i className="ri-user-line text-lg"></i>
                </a>
                <a href="#contact">
                  <button className="inline-flex items-center justify-center font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl px-6 py-3 text-base rounded-lg">
                    <span className="mr-2"><i className="ri-arrow-right-line"></i></span>Get in Touch
                  </button>
                </a>
              </div>
              <button 
                className="lg:hidden text-gray-600 hover:text-blue-600 transition-colors"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </header>

        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('https://public.readdy.ai/ai/img_res/5899ddbf8253b6cedbdcabbdbf01ff97.jpg')`
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
          </div>
          <div className="relative z-10 container mx-auto px-4 w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-screen">
              <div className="text-white">
                <div className="mb-6">
                  <span className="inline-block bg-blue-600/20 text-blue-300 px-4 py-2 rounded-full text-sm font-medium border border-blue-400/30">
                    <span className="text-blue-400">AI</span> Consulting Authority Inc.
                  </span>
                </div>
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                  Improve Your Business Idea With <span className="text-blue-400">AI Consulting Authority</span>
                </h1>
                <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
                  We are experienced professionals who care about your success. Transform your business with cutting-edge AI solutions tailored to your industry.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <button className="inline-flex items-center justify-center font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl px-8 py-4 text-lg rounded-lg">
                    <span className="mr-2"><i className="ri-calendar-line"></i></span>Schedule Free Consultation
                  </button>
                  <button className="inline-flex items-center justify-center font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer bg-gray-600 hover:bg-gray-700 text-white shadow-lg hover:shadow-xl px-8 py-4 text-lg rounded-lg">
                    <span className="mr-2"><i className="ri-play-line"></i></span>Watch Demo
                  </button>
                </div>
              </div>
              <div className="hidden lg:block"></div>
            </div>
          </div>
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
            <i className="ri-arrow-down-line text-2xl"></i>
          </div>
        </section>

        {/* Video Preview Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">See AI Consulting in Action</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Watch how we transform businesses through strategic AI implementation and consulting services.
              </p>
            </div>

            <div className="relative max-w-4xl mx-auto">
              <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl">
                <iframe
                  src="https://drive.google.com/file/d/11ZKpCCvCyLTHADUXFSne-19RIkZ5HmAM/preview"
                  title="AI Consulting Services Overview"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* Video Modal */}
        {isVideoModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
            <div className="relative max-w-4xl w-full mx-4">
              <button
                onClick={closeVideoModal}
                className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
              <div className="aspect-video rounded-lg overflow-hidden shadow-2xl">
                <iframe
                  src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
                  title="AI Consulting Services Overview"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        )}

        {/* Services Grid */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                { number: '01', icon: 'ri-settings-line', title: 'AI Workflow', desc: 'Streamline your business processes with intelligent automation and workflow optimization.', link: 'https://aiconsultingauthority.net/ai-workflow' },
                { number: '02', icon: 'ri-line-chart-line', title: 'AI Strategies', desc: 'Develop comprehensive AI strategies that align with your business goals and drive growth.', link: 'https://aiconsultingauthority.net/ai-strategies' },
                { number: '03', icon: 'ri-expand-diagonal-line', title: 'AI Scaling', desc: 'Scale your AI implementations efficiently across your organization for maximum impact.', link: 'https://aiconsultingauthority.net/ai-scaling' },
                { number: '04', icon: 'ri-robot-line', title: 'Avatar', desc: 'Create intelligent AI avatars and chatbots to enhance customer engagement.', link: 'https://aiconsultingauthority.net/ai-avatar' },
                { number: '05', icon: 'ri-edit-line', title: 'AI Prompt', desc: 'Large Language Models Training and Prompts optimization on GROK and other platforms.', link: 'https://aiconsultingauthority.net/ai-prompt' },
                { number: '06', icon: 'ri-shield-check-line', title: 'Cyber Security', desc: 'Comprehensive cybersecurity solutions to protect your business from digital threats.', link: 'https://aiconsultingauthority.net/cybersecurity' },
                { number: '07', icon: 'ri-cloud-line', title: 'Cloud Computing', desc: 'Scalable cloud solutions that grow with your business needs and requirements.', link: 'https://aiconsultingauthority.net/cloud-computing' },
                { number: '08', icon: 'ri-server-line', title: 'IT Management', desc: 'Comprehensive IT management solutions to optimize your technology infrastructure.', link: 'https://aiconsultingauthority.net/it-management' }
              ].map((service, index) => (
                <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 relative group">
                  <div className="absolute top-4 right-4 text-6xl font-bold text-gray-100 group-hover:text-blue-100 transition-colors">{service.number}</div>
                  <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-700 transition-colors">
                    <i className={`${service.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 group-hover:text-blue-600 transition-colors">{service.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{service.desc}</p>
                  <a href={service.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold whitespace-nowrap cursor-pointer">
                    Read More<i className="ri-arrow-right-line ml-2"></i>
                  </a>
                  <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-600 to-blue-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Marquee Section */}
        <section className="bg-blue-600 py-4 overflow-hidden">
          <div className="flex animate-marquee whitespace-nowrap">
            {[
              'A free consultation for Future',
              'A free consultation for Development', 
              'A free consultation for design',
              'A free Development Course',
              'A free consultation for Research',
              'A free consultation for Future'
            ].map((text, index) => (
              <div key={index} className="flex items-center mx-8">
                <i className="ri-play-line text-white mr-3"></i>
                <span className="text-blue-200 font-semibold mr-2">Get Now:</span>
                <span className="text-white">{text}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Main Services Section */}
        <section id="services" className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <div className="flex items-center justify-center mb-4">
                <div className="w-6 h-2 bg-gradient-to-r from-blue-600 to-blue-400 rounded-full mr-3 shadow-lg"></div>
                <span className="text-blue-600 font-semibold uppercase tracking-wider">Service</span>
                <div className="w-6 h-2 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full ml-3 shadow-lg"></div>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Our <span className="text-blue-600">Services</span></h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">AI Business Services</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                { 
                  title: 'AI Prompt', 
                  desc: 'Optimize your AI interactions with expertly crafted prompts that deliver precise, actionable results for your business needs.',
                  image: 'https://public.readdy.ai/ai/img_res/488d350e5d264d31eca04faca738080f.jpg',
                  icon: 'ri-robot-line',
                  link: 'https://aiconsultingauthority.net/ai-prompt'
                },
                { 
                  title: 'Cyber Security', 
                  desc: 'Protect your digital assets with comprehensive security solutions, threat detection, and proactive defense strategies.',
                  image: 'https://public.readdy.ai/ai/img_res/4ace9ac01a09b204e6a9e7d9c5fefae7.jpg',
                  icon: 'ri-shield-check-line',
                  link: 'https://aiconsultingauthority.net/cybersecurity'
                },
                { 
                  title: 'Cloud Computing', 
                  desc: 'Scale your infrastructure with secure, flexible cloud solutions that grow with your business and optimize costs.',
                  image: 'https://readdy.ai/api/search-image?query=Cloud%20computing%20technology%20concept%20with%20floating%20cloud%20servers%20and%20data%20centers%2C%20modern%20digital%20infrastructure%20visualization%2C%20professional%20technology%20background%20with%20white%20clouds%20and%20blue%20sky%2C%20scalable%20cloud%20services%20representation%20with%20network%20connections%20and%20data%20flow&width=600&height=400&seq=cloud-computing-service-001&orientation=landscape',
                  icon: 'ri-cloud-line',
                  link: 'https://aiconsultingauthority.net/cloud-computing'
                },
                { 
                  title: 'IT Management', 
                  desc: 'Streamline your technology operations with expert IT management, support, and strategic planning services.',
                  image: 'https://readdy.ai/api/search-image?query=IT%20management%20and%20technology%20operations%20concept%20with%20server%20racks%20and%20network%20equipment%2C%20professional%20data%20center%20environment%2C%20modern%20technology%20infrastructure%20with%20organized%20cables%20and%20monitoring%20systems%2C%20corporate%20IT%20support%20and%20management%20visualization&width=600&height=400&seq=it-management-service-001&orientation=landscape',
                  icon: 'ri-settings-3-line',
                  link: 'https://aiconsultingauthority.net/it-management'
                }
              ].map((service, index) => (
                <div key={index} className="group bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden">
                  <div className="relative overflow-hidden">
                    <img 
                      alt={service.title} 
                      className="w-full h-48 object-cover object-top group-hover:scale-110 transition-transform duration-300" 
                      src={service.image}
                    />
                    <div className="absolute inset-0 bg-blue-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <div className="p-6 relative">
                    <div className="absolute top-0 right-0 w-20 h-20 bg-blue-50 rounded-bl-full opacity-50"></div>
                    <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-700 transition-colors relative z-10">
                      <i className={`${service.icon} text-white text-2xl`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">{service.title}</h3>
                    <p className="text-gray-600 mb-4 leading-relaxed">{service.desc}</p>
                    <a className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold transition-colors group/link" href={service.link} target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-book-open mr-2"></i>Read More<i className="fas fa-arrow-right ml-2 group-hover/link:translate-x-1 transition-transform"></i>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="py-20 bg-gray-900 text-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <span className="text-blue-400 font-semibold uppercase tracking-wider">Features</span>
              <h2 className="text-4xl md:text-5xl font-bold mb-4">Our <span className="text-blue-400">Features</span></h2>
              <p className="text-xl text-gray-300 max-w-2xl mx-auto">There are many variations words pulvinar dapibus passages dont available.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                { icon: 'ri-brush-line', title: 'AI Consulting', desc: 'Build smarter roadmaps to align AI with business growth and goals.', link: '#contact' },
                { icon: 'ri-emotion-happy-line', title: 'AI Chatbots', desc: 'Engage customers instantly with intelligent, personalized chatbot interactions.', link: '#contact' },
                { icon: 'ri-team-line', title: 'AI Strategy', desc: 'Build smarter roadmaps to align AI with business growth for your team.', link: '#contact' },
                { icon: 'ri-tv-line', title: 'AI Data Insights', desc: 'Turn data into actionable insights that drive better decisions.', link: '#contact' },
                { icon: 'ri-list-check-line', title: 'AI Training & Workshops', desc: 'Empower your team with hands-on, practical AI skill and training.', link: '#contact' },
                { icon: 'ri-stethoscope-line', title: 'AI Content Creation', desc: 'Generate engaging content quickly with advanced AI assistance.', link: '#contact' },
                { icon: 'ri-shopping-bag-line', title: 'E-commerce AI', desc: 'Optimize your online store with intelligent product recommendations and automation.', link: '#contact' },
                { icon: 'ri-magnet-line', title: 'AI Marketing Solutions', desc: 'Boost campaign performance with AI-powered marketing automation.', link: '#contact' }
              ].map((feature, index) => (
                <div key={index} className="group relative">
                  <div className="absolute -top-2 -left-2 w-full h-full bg-blue-600/10 rounded-lg transform rotate-3 group-hover:rotate-6 transition-transform duration-300"></div>
                  <div className="absolute -bottom-2 -right-2 w-full h-full bg-blue-400/10 rounded-lg transform -rotate-3 group-hover:-rotate-6 transition-transform duration-300"></div>
                  <div className="relative bg-gray-800 rounded-lg p-6 hover:bg-gray-700 transition-all duration-300 border border-gray-700 hover:border-blue-500">
                    <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-500 transition-colors">
                      <i className={`${feature.icon} text-white text-2xl`}></i>
                    </div>
                    <h3 className="text-xl font-bold mb-3 group-hover:text-blue-400 transition-colors">{feature.title}</h3>
                    <p className="text-gray-300 mb-4 leading-relaxed">{feature.desc}</p>
                    <div className="flex justify-center">
                      <a href={feature.link} className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center hover:bg-blue-500 transition-colors group/btn cursor-pointer">
                        <i className="ri-arrow-right-line text-white group-hover/btn:translate-x-1 transition-transform duration-300"></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Section */}
        <section id="blog" className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <div className="flex items-center justify-center mb-4">
                <div className="w-4 h-4 bg-gradient-to-r from-blue-600 to-blue-400 rounded-sm rotate-45 mr-3 shadow-lg"></div>
                <span className="text-blue-600 font-semibold uppercase tracking-wider">Our Blog</span>
                <div className="w-4 h-4 bg-gradient-to-r from-blue-400 to-blue-600 rounded-sm rotate-45 ml-3 shadow-lg"></div>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Our <span className="text-blue-600">Blog</span></h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">There are many variations words pulvinar dapibus passages dont available.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
              <article className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
                <div className="p-6 border-b border-gray-100">
                  <div className="flex items-center mb-4">
                    <i className="ri-folder-line text-blue-600 mr-2"></i>
                    <span className="text-blue-600 font-medium">About</span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center space-x-4 mb-4 text-sm text-gray-500">
                    <div className="flex items-center">
                      <i className="ri-user-line mr-2"></i>
                      <span>AI Consulting Authority</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-calendar-line mr-2"></i>
                      <span>March 15, 2024</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 group-hover:text-blue-600 transition-colors">
                    <a href="https://aiconsultingauthority.net/about" target="_blank" rel="noopener noreferrer">Bio</a>
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed line-clamp-4">Learn about our expertise and commitment to transforming businesses through AI innovation.</p>
                  <a href="https://aiconsultingauthority.net/about" target="_blank" rel="noopener noreferrer">
                    <button className="inline-flex items-center justify-center font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-4 py-2 text-sm rounded-md group-hover:bg-blue-600 group-hover:text-white group-hover:border-blue-600">
                      <span className="mr-2"><i className="ri-arrow-right-line"></i></span>Read More
                    </button>
                  </a>
                </div>
              </article>

              <article className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
                <div className="p-6 border-b border-gray-100">
                  <div className="flex items-center mb-4">
                    <i className="ri-folder-line text-blue-600 mr-2"></i>
                    <span className="text-blue-600 font-medium">AI Strategy</span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center space-x-4 mb-4 text-sm text-gray-500">
                    <div className="flex items-center">
                      <i className="ri-user-line mr-2"></i>
                      <span>Marketing Team</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-calendar-line mr-2"></i>
                      <span>March 10, 2024</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 group-hover:text-blue-600 transition-colors">
                    <a href="https://aiconsultingauthority.net/ai-strategies" target="_blank" rel="noopener noreferrer">How AI Attracts New Customers</a>
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed line-clamp-4">Discover proven strategies for leveraging artificial intelligence to expand your customer base and drive sustainable growth.</p>
                  <a href="https://aiconsultingauthority.net/ai-strategies" target="_blank" rel="noopener noreferrer">
                    <button className="inline-flex items-center justify-center font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-4 py-2 text-sm rounded-md group-hover:bg-blue-600 group-hover:text-white group-hover:border-blue-600">
                      <span className="mr-2"><i className="ri-arrow-right-line"></i></span>Read More
                    </button>
                  </a>
                </div>
              </article>
            </div>

            <div className="text-center mt-12">
              <a href="https://aiconsultingauthority.net/blog" target="_blank" rel="noopener noreferrer">
                <button className="inline-flex items-center justify-center font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl px-8 py-4 text-lg rounded-lg">
                  <span className="mr-2"><i className="ri-arrow-right-line"></i></span>View All Posts
                </button>
              </a>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <div className="mb-8">
                  <span className="text-blue-600 font-semibold uppercase tracking-wider">Contact Us</span>
                  <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Get Your <span className="text-blue-600">Free Consultation</span></h2>
                  <p className="text-xl text-gray-600">Ready to transform your business with AI? Let's discuss your needs and create a customized solution.</p>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Our Address</h3>
                      <p className="text-gray-600">725 E Road 2 N Unit 1494<br />Chino Valley, AZ 86323</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Phone Number</h3>
                      <p className="text-gray-600">928-963-2760</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Email Address</h3>
                      <p className="text-gray-600">jeffery@aiconsultingauthority.com</p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-linkedin-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">LinkedIn</h3>
                      <a 
                        href="https://www.linkedin.com/in/jeffery-long-23b02a38a/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-700 transition-colors"
                      >
                        Connect with me
                      </a>
                    </div>
                  </div>
                </div>

                {/* Service Area Map */}
                <div className="mt-8">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Service Areas</h3>
                  <p className="text-gray-600 mb-4">
                    Providing AI consulting services globally with headquarters in Northern California.
                  </p>
                  
                  <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d804686.2922526915!2d-122.3301083!3d38.5816223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809ac672b28397f9%3A0x921f6aaa74197fdb!2sSacramento%2C%20CA!5e0!3m2!1sen!2sus!4v1697000000000!5m2!1sen!2sus"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Service Areas Map"
                    ></iframe>
                  </div>
                  
                  <div className="mt-4 text-sm text-gray-600">
                    <p><strong>Headquarters:</strong> Sacramento, CA</p>
                    <p><strong>Service Areas:</strong> Global AI consulting with focus on North American businesses</p>
                  </div>
                </div>

                {/* Back to Business Pages */}
                <div className="mt-8 p-6 bg-gray-50 rounded-lg">
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Explore My Other Services</h4>
                  <div className="space-y-2">
                    <a href="/real-estate" className="block text-blue-600 hover:text-blue-700 transition-colors">
                      <i className="ri-arrow-right-line mr-2"></i>Real Estate Development
                    </a>
                    <a href="/ai-book" className="block text-blue-600 hover:text-blue-700 transition-colors">
                      <i className="ri-arrow-right-line mr-2"></i>AI Book Authority
                    </a>
                    <a href="/travel-authority" className="block text-blue-600 hover:text-blue-700 transition-colors">
                      <i className="ri-arrow-right-line mr-2"></i>Travel Authority
                    </a>
                    <a href="/books" className="block text-blue-600 hover:text-blue-700 transition-colors">
                      <i className="ri-arrow-right-line mr-2"></i>Published Books
                    </a>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-2xl p-8">
                <form data-readdy-form onSubmit={handleFormSubmit} id="contact-form">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Full Name *</label>
                      <input 
                        id="name" 
                        required 
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-505 focus:border-transparent text-sm" 
                        placeholder="Enter your full name" 
                        name="name"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Email Address *</label>
                      <input 
                        id="email" 
                        required 
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-505 focus:border-transparent text-sm" 
                        placeholder="Enter your email" 
                        type="email" 
                        name="email"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                      <input 
                        id="phone" 
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-505 focus:border-transparent text-sm" 
                        placeholder="Enter your phone number" 
                        type="tel" 
                        name="phone"
                      />
                    </div>
                    <div>
                      <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">Company Name</label>
                      <input 
                        id="company" 
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-505 focus:border-transparent text-sm" 
                        placeholder="Enter your company name" 
                        name="company"
                      />
                    </div>
                  </div>

                  <div className="mb-6">
                    <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">Service Interest</label>
                    <div className="relative">
                      <select 
                        id="service" 
                        name="service" 
                        className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-505 focus:border-transparent text-sm appearance-none bg-white"
                      >
                        <option value="">Select a service</option>
                        <option value="ai-consulting">AI Consulting</option>
                        <option value="ai-strategy">AI Strategy</option>
                        <option value="ai-implementation">AI Implementation</option>
                        <option value="ai-training">AI Training & Workshops</option>
                        <option value="cybersecurity">Cybersecurity</option>
                        <option value="cloud-computing">Cloud Computing</option>
                        <option value="it-management">IT Management</option>
                      </select>
                      <i className="ri-chevron-down-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                    </div>
                  </div>

                  <div className="mb-6">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">Message *</label>
                    <textarea 
                      id="message" 
                      name="message" 
                      required 
                      maxLength={500} 
                      rows={4} 
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-505 focus:border-transparent text-sm resize-vertical" 
                      placeholder="Tell us about your project and requirements..."
                    ></textarea>
                    <div className="text-right text-xs text-gray-500 mt-1">0/500 characters</div>
                  </div>

                  <button 
                    type="submit"
                    className="inline-flex items-center justify-center font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl px-8 py-4 text-lg rounded-lg w-full"
                  >
                    <span className="mr-2"><i className="ri-send-plane-line"></i></span>Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-blue-600 text-white">
          <div className="py-16">
            <div className="container mx-auto px-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
                <div className="group">
                  <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-4 group-hover:bg-white/20 transition-colors">
                    <i className="ri-mail-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Email Us 24/7</h3>
                  <a href="mailto:jeffery@aiconsultingauthority.com" className="text-blue-100 hover:text-white transition-colors">jeffery@aiconsultingauthority.com</a>
                </div>

                <div className="group">
                  <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-4 group-hover:bg-white/20 transition-colors">
                    <i className="ri-question-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Have Questions?</h3>
                  <a className="text-blue-100 hover:text-white transition-colors" href="#contact">Contact Us</a>
                </div>

                <div className="group">
                  <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-4 group-hover:bg-white/20 transition-colors">
                    <i className="ri-phone-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Call Us 24/7</h3>
                  <a href="tel:+1-928-963-2760" className="text-blue-100 hover:text-white transition-colors">+1-928-963-2760</a>
                </div>

                <div className="group">
                  <div className="w-16 h-16 bg-white/10 rounded-lg flex items-center justify-center mx-auto mb-4 group-hover:bg-white/20 transition-colors">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">Opening Hours</h3>
                  <span className="text-blue-100">Mon-Sat: 10-6 PM</span>
                </div>
              </div>
            </div>
          </div>

          <div className="py-16 bg-blue-700">
            <div className="container mx-auto px-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div>
                  <h5 className="text-xl font-bold mb-4">Quick Contact Info</h5>
                  <div className="w-16 h-1 bg-white mb-4"></div>
                  <p className="text-blue-100 mb-6 leading-relaxed">AI Consulting Authority is dedicated to helping businesses harness the power of artificial intelligence with confidence and clarity.</p>
                  
                  <div className="space-y-3">
                    <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                      <i className="ri-map-pin-line text-white"></i>
                    </div>
                    <div>
                      <p className="text-gray-300">725 E Road 2 N Unit 1494</p>
                      <p className="text-gray-300">Chino Valley, AZ 86323</p>
                    </div>
                  </div>
                  
                  <div className="mt-6">
                    <h6 className="text-sm font-semibold text-gray-200 mb-3">Follow Us</h6>
                    <div className="flex space-x-3">
                      <a href="https://www.facebook.com/profile.php?id=61587057361355" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full cursor-pointer hover:bg-blue-500 transition-colors">
                        <i className="ri-facebook-fill text-sm"></i>
                      </a>
                      <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-pink-500 via-red-500 to-yellow-500 rounded-full cursor-pointer hover:opacity-80 transition-opacity">
                        <i className="ri-instagram-fill text-sm"></i>
                      </div>
                      <div className="w-8 h-8 flex items-center justify-center bg-red-600 rounded-full cursor-pointer hover:bg-red-700 transition-colors">
                        <i className="ri-youtube-fill text-sm"></i>
                      </div>
                      <div className="w-8 h-8 flex items-center justify-center bg-blue-800 rounded-full cursor-pointer hover:bg-blue-900 transition-colors">
                        <i className="ri-linkedin-fill text-sm"></i>
                      </div>
                      <div className="w-8 h-8 flex items-center justify-center bg-black rounded-full cursor-pointer hover:bg-gray-800 transition-colors">
                        <i className="ri-tiktok-fill text-sm"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <h5 className="text-xl font-bold mb-4">Our Services</h5>
                  <div className="w-16 h-1 bg-white mb-4"></div>
                  <ul className="space-y-2">
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">AI Consulting</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">AI Strategy Development</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">AI Implementation</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">AI Scaling Solutions</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">AI Training & Workshops</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="https://aiconsultingauthority.net/ai-content" target="_blank" rel="noopener noreferrer">AI Content Creation</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">AI Prompt Engineering</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">AI Avatar Solutions</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">Cybersecurity</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">Cloud Computing</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">IT Management</a></li>
                  </ul>
                </div>

                <div>
                  <h5 className="text-xl font-bold mb-4">Quick Links</h5>
                  <div className="w-16 h-1 bg-white mb-4"></div>
                  <ul className="space-y-2">
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="/">Home</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="/ai-consulting">AI Consulting</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="/real-estate">Real Estate</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="/ai-book">AI Books</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="/travel-authority">Travel</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="/books">Books</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="#contact">Contact</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="https://travelauthority.net/" target="_blank" rel="noopener noreferrer">Travel Authority</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="https://aiconsultingauthority.net/" target="_blank" rel="noopener noreferrer">AI Consulting Authority</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="https://aibookauthority.net/" target="_blank" rel="noopener noreferrer">AI Book Authority</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="https://realestatedevelopmentauthority.net/" target="_blank" rel="noopener noreferrer">Real Estate Development Authority</a></li>
                    <li><a className="text-blue-100 hover:text-white transition-colors" href="https://realestatedevelopment.net/" target="_blank" rel="noopener noreferrer">Real Estate Development & eXp</a></li>
                  </ul>
                </div>

                <div>
                  <h5 className="text-xl font-bold mb-4">Newsletter</h5>
                  <div className="w-16 h-1 bg-white mb-4"></div>
                  <p className="text-blue-100 mb-4">Subscribe to get the latest AI insights and updates.</p>
                  
                  <form data-readdy-form onSubmit={handleNewsletterSubmit} id="newsletter-form">
                    <div className="flex flex-col space-y-3">
                      <input 
                        placeholder="Enter your email" 
                        required 
                        className="px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-blue-200 focus:outline-none focus:ring-2 focus:ring-white/50 text-sm" 
                        type="email" 
                        name="email"
                      />
                      <button 
                        type="submit"
                        className="inline-flex items-center justify-center font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer bg-white text-blue-600 hover:bg-blue-50 shadow-lg hover:shadow-xl px-4 py-2 text-sm rounded-md"
                      >
                        <span className="mr-2"><i className="ri-send-plane-line"></i></span>Subscribe
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="py-6 bg-blue-800 border-t border-blue-600">
            <div className="container mx-auto px-4">
              <div className="text-center">
                <p className="text-blue-100">Copyright © 2025. Created by AI Consulting Authority. <a href="https://readdy.ai/?origin=logo" className="text-white hover:text-blue-200 transition-colors ml-1">Powered by Readdy</a></p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AIConsultingPage;